export const DATA_CHANNEL_MSG_TYPE_VIDEO_FINAL = 1;
export const DATA_CHANNEL_MSG_TYPE_VIDEO_START = 2;
export const DATA_CHANNEL_MSG_TYPE_AUDIO = 4;

export const OFFSET_NTP_TIMESTAMP = 0 * 8;
export const OFFSET_DECODE_TIME = 1 * 8;
export const OFFSET_CODEC_TYPE = 2 * 8;
export const OFFSET_ROTATION = 2 * 8 + 4;
export const OFFSET_MP4_DATA = 2 * 8 + 4 + 4;

export const MAX_MESSAGE_LENGTH = 10 * 1000 * 1000; // 10 MB

export const PONG = { type: 'pong' };
